export default "__VITE_ASSET__CdKKSWdZ__"